export default __webpack_public_path__ + "static/media/white-detail.3fda4078.svg";